import type { PropsWithChildren } from "react";
import { useFeatures } from "~api/features";
import { Spinner } from "~components/shared/Loading/Spinner/Spinner.tsx";

// Only gates the very first load (no data cached yet for any tenant); a
// tenant switch keeps isPending false (see useFeatures), so guards below
// still need their own isPlaceholderData check for that case.
export function RequireFeaturesLoaded({ children }: PropsWithChildren) {
  const { isPending } = useFeatures();

  if (isPending) {
    return <Spinner />;
  }

  return <>{children}</>;
}
